module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","submit":"Submit"},"id":{"cancel":"Batal","submit":"Hantar"}}')
  delete Component.options._Ctor
}
